import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e4a05a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-title px-2 mt-3 fs-5" }
const _hoisted_2 = { class: "card-text" }
const _hoisted_3 = {
  style: {"font-size":"14px"},
  class: "my-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-puzzle-piece" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-play" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { computed, reactive, ref } from "vue";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import { UserBlockContents } from "../../../../server/dto/generated/UserBlockContents";
import { DT_FORMAT } from "../../../../framework/util/momentExtends";
import { translation } from '../../../lang/Translation';
import { AuthUser } from "../../../../server/dto/AuthUser";
import { DialogHandler } from '../../../components/dialog/DialogHandler';
import { ClassMembers } from '../../../../server/dto/generated/ClassMembers';
import { classRoomContext } from "../logics/ClassRoomContext";
import { ContentsUrl } from "../../../utils/ContentsUrl";
import { SessionUser } from '../../../utils/SessionUser';

interface Prop {
  item: UserBlockContents;
  member: ClassMembers;
  class: any;
  onReload: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PresentationCardItem',
  props: {
    item: null,
    member: null,
    class: null,
    onReload: null
  },
  setup(__props: any) {

const props = __props as {
  item: UserBlockContents;
  member: ClassMembers;
  class: any;
  onReload: () => void;
};



const item = reactive(props.item);
const contentsUrl = ContentsUrl.instance.getUrl( item.project_id,SessionUser.instance.userId);

const updataDt = computed(() => {
  return dayjs(item.update_dt).format(DT_FORMAT);
});
const openExecute = ()=>{
  window.open(contentsUrl,"_blank")
}
/**
 * 動的ラベル
 */
// ユーザーのプロジェクト保存時の画像
const imagePath = `/assets/${item.user_id}/project/${item.project_id}.png`;

// プロジェクト選択
const selectRow = () => {
  classRoomContext.blockXml.value = item.block_xml;
  classRoomContext.contentsUrl.value = contentsUrl
  DialogHandler.showClassRoomProgramDialog()
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gx-3 w-100 p-1 border-light card", { member_item: item.member_id !== _unref(AuthUser).NO_CLASS_MEMBER }])
  }, [
    _createElementVNode("img", {
      class: "w-100 img-responsive",
      src: imagePath,
      onerror: "this.src='/public/list_back_noimage.png'",
      lazyload: "",
      onClick: selectRow
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(item.title), 1),
    _createElementVNode("div", {
      class: "card-body",
      onClick: selectRow
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "Member : " + _toDisplayString(__props.member.name) + " [ " + _toDisplayString(__props.member.member_id) + " ]", 1),
          _createElementVNode("div", null, "ID : " + _toDisplayString(item.project_id), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(updataDt)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", { class: "card-text" }, [
      _createElementVNode("div", {
        style: {"font-size":"14px"},
        class: "my-3 d-flex justify-content-between px-3"
      }, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg btn-w me-2",
          onClick: selectRow
        }, _hoisted_5),
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg btn-w",
          onClick: openExecute
        }, _hoisted_7)
      ])
    ])
  ], 2))
}
}

})